import { MojeFce as Fce } from "../global/fce.js";
var Top = {
  localhost: false, //skript pousten pouze prez vlastni html testovaci strankuwindow.ladzoServer=true;
  ladzoServer: false, //true vzdy pokud jde o testovani
  nodeServer: false, //true vzdy pokud jde o testovani

  localStorageName: "ladzoCzMap",

  DataLayer: {},
  //mapy_cz_api_key: "MmLVl5rC1r9xB0twl3JW4-ywmrDEDz9fheFOtubxxQk",
  mapy_cz_api_key: "o7NK4nYMxc2UjipQmxCrXEYFdNdJgjKvxGEkQ-xfCGo", //MAPA-Key-01
  mapy_cz_api_key_localhost: "61jMNxz9lSdMdIcvrk760HKdn-2-JAcj5_zkeAWUqvI", //	mapa-ladzo-dev-key-02
  //https://manage.thunderforest.com/dashboard
  thunderforest_api_key: "c53c0666ebce46d68a1a8d2669b809e6",

  filtrySkladem: false, //novy typ filtru pro skladem
  videaProduktu: false,
  obr_editor_src: "https://admin.velosprint.sk/obr/edit/",
  url_link: "https://www.velosprint.sk/",
  url: "www.velosprint.sk",
  admin_url: "https://admin.velosprint.sk/",
  admin_test_url: "https://admin.velosprint.tld/",
  urlAutorizovanyDealer:
    "https://www.velosprint.sk/clanky/velosprint-sk-autorizovany-predajca-specialized/",
  svatky: [],
  velikonocni_pondeli: [],
  Drobecky: {},
  screenMobil: false,
  Screen: {
    1199: false,
    991: false,
  },
  is_mobil: function () {
    return this.screenMobil;
  },
  is_screen: function (size) {
    return this.Screen[size];
  },
  getLocalStorageKey: function (name) {
    return `${this.localStorageName}_${name}`;
  },
  _init: function () {
    if ($("body").hasClass("mobile")) {
      this.screenMobil = true;
    }
    if (window.innerWidth <= 767) {
      this.screenMobil = true;
    }
    if (window.innerWidth <= 1199) {
      this.Screen["1199"] = true;
    }
    if (window.innerWidth <= 991) {
      this.Screen["991"] = true;
    }
    let o = Fce.prom("svatky") || false;
    if (o) {
      this.svatky = o.a.split(",");
      this.velikonocni_pondeli = o.p.split(",");
    }
    this.nacti_drobecky();
  },
  nacti_drobecky: function () {
    let t = this;
    $(".breadcrumbs >span").each(function (index) {
      let span = $(this);
      if (span.attr("id") == "navigation-first") return;

      let a = span.find(">a");
      let link = "";
      let urlLink = false;
      if (a.length) {
        link = a.find(">span").text();
        urlLink = a.attr("href");
      } else {
        link = span.find('span[itemprop="name"]').text();
        urlLink = false;
        t.Drobecky["pocet"] = index;
      }

      t.Drobecky["level_" + index] = {
        text: link,
        url: urlLink,
      };
    });
  },
};

Top._init();

export { Top };
